import * as api from '../api'
import { AUTHENTICATED, NOT_AUTHENTICATED, GROUPS, USERS, ERROR_AUTHENTICATION } from '../constants/actionTypes.js'
import { resetConfirmActions } from './notifications.js';

const setToken = (token, expIn) => {
    const now = new Date(Date.now()).getTime()
    localStorage.setItem("token", token);
    localStorage.setItem("tokenExp", now + (expIn*1000))
};

const setAuthToken = (token, expIn) => {
    const now = new Date(Date.now()).getTime()
    localStorage.setItem("authToken", token);
    localStorage.setItem("authTokenExp", now + (expIn*1000))
};

const setInitialUser = (user) => {
    localStorage.setItem("initialUser", JSON.stringify(user));
}

const setUser = (user) => {
    localStorage.setItem("user", JSON.stringify(user));
}

export const getUserProvider = () => {
    return JSON.parse(localStorage.getItem("user")) && JSON.parse(localStorage.getItem("user")).groups
}

export const isAdminDSAS = () => {
    return JSON.parse(localStorage.getItem("user")) && JSON.parse(localStorage.getItem("user")).role === 'admin' && JSON.parse(localStorage.getItem("user")).admin === true
}

export const isAdminUser = () => {
    return JSON.parse(localStorage.getItem("user")) && JSON.parse(localStorage.getItem("user")).role === 'admin'
}

export const isWriterUser = () => {
    return JSON.parse(localStorage.getItem("user")) && JSON.parse(localStorage.getItem("user")).role === 'write'
}

export const isReaderUser = () => {
    return JSON.parse(localStorage.getItem("user")) && JSON.parse(localStorage.getItem("user")).role === 'read'
}

export const getInitialUser = () => {
    return JSON.parse(localStorage.getItem("initialUser"));
}

export const getUser = () => {
    return JSON.parse(localStorage.getItem("user"));
}

export const getToken = () => {
    const now = new Date(Date.now()).getTime();
    const exp = localStorage.getItem("tokenExp");

    if (now < exp) {
        return localStorage.getItem("token");
    }
};

export const getAuthToken = () => {
    const now = new Date(Date.now()).getTime();
    const exp = localStorage.getItem("authTokenExp");

    if (now < exp) {
        return localStorage.getItem("authToken");
    }
};

const deleteToken = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("tokenExp");

    localStorage.removeItem("authToken");
    localStorage.removeItem("authTokenExp");
}

const deleteUser = () => {
    localStorage.removeItem("user");
}

export const loginUser = ({user, password}) => {
    return async (dispatch) => {

        try {
            let credentials = {user, password}

            let { data } = await api.loginUser(credentials)

            if(!data.collectorToken){
                dispatch({ type: NOT_AUTHENTICATED }); 
            }else{
                const {authToken, collectorToken} = data

                const {access_token, expires_in} = collectorToken
                setToken(access_token, expires_in);

                if(authToken){
                    const {access_token : token, expires_in : expires} = authToken
                    setAuthToken(token, expires);
                }
                

                let resp = await api.checkUser()

                setUser(resp.data.user)

                // pour le widget roles
                setInitialUser(resp.data.user)

                dispatch({ type: AUTHENTICATED, payload: resp.data.user })
            }
        }catch(error){
            dispatch({ type: NOT_AUTHENTICATED });
            dispatch({ type: ERROR_AUTHENTICATION, payload : {error : "Identifiant ou mot de passe non reconnu."} });
            
        }
   };
};
  
export const logoutUser = () => {
    return async (dispatch) => {
        deleteToken();
        deleteUser();
        localStorage.removeItem("initialUser");
        dispatch(resetConfirmActions());

        dispatch({ type: NOT_AUTHENTICATED });
        
    }
}

export const checkUser = () => {
    return async (dispatch) => {
        try {
            const {data} = await api.checkUser()      

            data.user ? dispatch({type: AUTHENTICATED, payload: data.user}) : dispatch({type: NOT_AUTHENTICATED})
        }catch(error){
            dispatch({type: NOT_AUTHENTICATED})
        }
    }
};

export const getGroups = () => {
    return async (dispatch) => {
        try {
            const {data} = await api.getGroups()      

            dispatch({type: GROUPS, payload: data})
        }catch(error){
            dispatch({type: NOT_AUTHENTICATED})
        }
    }
}

export const getUsers = () => {
    return async (dispatch) => {
        try {
            const {data} = await api.getUsers()
            
            data.sort((a,b) => {
                return a.userName.localeCompare(b.userName)
            })

            dispatch({type: USERS, payload : data.map(u => ({_id : u.userName, name : u.userName, provider : u.provider}))})
        }catch(error){
            dispatch({type: NOT_AUTHENTICATED})
        }
    }
}